/* eslint no-restricted-syntax: 0 */
export default function filterProps(restProps, propTypes) {
    const newProps = {};
    for (const i in restProps) {
        if (restProps && {}.hasOwnProperty.call(restProps, i) && propTypes && !{}.hasOwnProperty.call(propTypes, i)) {
            newProps[i] = restProps[i];
        }
    }
    return newProps;
}



// WEBPACK FOOTER //
// ./src/SharedComponents/filterProps.js